import { TEACHING_THE_UNIT_ROUTE_PREFIX } from '../constants'

const TRAINING_COURSE_CODE_BY_CONTENT_GROUP_AND_BAND = {
  dwb: {
    'k-5': 'k-5_dwb-training_tier-1_educator',
    '6-8': '6-8_dwb-training_tier-1_educator',
    '9-12': '9-12_dwb-training_tier-1_educator',
  },
}

function extractTrainingRouteBand(route) {
  if (typeof route !== 'string' || !route.trim()) return null

  // Curriculum-service may send a bare slug ("teaching-the-unit-k-5") or a path
  // fragment ("/training/teaching-the-unit-k-5"). /^\/+/ strips leading slashes so
  // both shapes normalize the same way before we read the final segment.
  const normalizedRoute = route.trim().replace(/^\/+/, '')
  // Keep only the last path segment so "/training/teaching-the-unit-k-5" and
  // "teaching-the-unit-k-5" both resolve to the same slug for band matching.
  const slug = normalizedRoute.split('/').pop() || normalizedRoute

  if (!slug.startsWith(TEACHING_THE_UNIT_ROUTE_PREFIX)) return null

  const band = slug
    .slice(TEACHING_THE_UNIT_ROUTE_PREFIX.length)
    .replace(/^-/, '')
  return band || null
}

function resolveTrainingCourseCode({ trainingLinkSummary, contentGroupCode }) {
  const normalizedContentGroupCode = String(
    contentGroupCode || '',
  ).toLowerCase()
  const routeBand = extractTrainingRouteBand(trainingLinkSummary?.route)
  if (!routeBand) return null

  return (
    TRAINING_COURSE_CODE_BY_CONTENT_GROUP_AND_BAND[
      normalizedContentGroupCode
    ]?.[routeBand] || null
  )
}

/**
 * Resolves the curriculum-service coursePointer for a unit's training summary.
 * Prefers an explicit pointer on the summary; falls back to route-band mapping.
 */
export function resolveTrainingCoursePointer({
  trainingLinkSummary,
  contentGroupCode,
}) {
  if (!trainingLinkSummary) return null

  if (trainingLinkSummary.coursePointer)
    return trainingLinkSummary.coursePointer

  const courseCode = resolveTrainingCourseCode({
    trainingLinkSummary,
    contentGroupCode,
  })

  if (!courseCode) return null

  return {
    query: {
      courseCode,
    },
  }
}

/**
 * Resolves the LMS course node id for a unit's training summary from
 * courseNodeConnector metadata when curriculum-service provides it.
 */
export function resolveTrainingCourseNodeId(trainingLinkSummary) {
  if (!trainingLinkSummary) return null

  const connector = trainingLinkSummary.courseNodeConnector
  return (
    connector?.courseNodeEntryPoint ||
    connector?.course_node_entry_point ||
    null
  )
}
